// Modules
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import uniqueId from 'lodash/uniqueId';
import get from 'lodash/get';
// Components
import Link from 'react-router/lib/Link';
import HeaderPhones from '../HeaderPhones/HeaderPhones';
// Helper
import appendLocale from '../../../helpers/appendLocale';
import formatAddress from '../../../utils/formatAddress';
// Constants
import { brokerCommunityStamp, brokerAssociationStamp, purpleStamp, language } from '../../../constants';
// styles
import * as styles from './AboutCompany.scss';

const PURPLE_STAMP_ARTICLE_LINK = '/articles/B11Zlhoj8';

const AboutCompany = props => {
  const communityLogo = { backgroundImage: `url('${brokerCommunityStamp}')` };
  const associationLogo = { backgroundImage: `url('${brokerAssociationStamp}')` };
  const purpleStampLogo = { backgroundImage: `url('${purpleStamp}')` };

  const renderCompanyBranch = (name, address, isDefaultLang) => (
    <p className={cx(styles.addressBlock, { [styles.defaultLang]: isDefaultLang })} key={uniqueId('branch')}>
      <span className="icon icon-office" />
      {name || props.translate('filial')}:&nbsp;&nbsp;{address}
    </p>
  );

  const renderAddress = address => (
    <p className={styles.addressBlock}>
      <span className="icon icon-office" />
      {props.translate('address')}:&nbsp;&nbsp;{address}
    </p>
  );

  const renderCompanyBranches = () => {
    const { branches, locale } = props;

    if (branches && branches.length === 1) {
      const address = get(branches, '[0].address') || {};
      const formattedAddress = (typeof address === 'string')
        ? address
        : formatAddress(address[locale] || address.en);

      return renderAddress(formattedAddress);
    }

    return branches.map(({ name, address }) => {
      const localizedName = name && (name[locale] || name[language.default]);
      const isNameAtDefaultLang = name && !name[locale];
      const formattedAddress = (typeof address === 'string')
        ? address
        : formatAddress(address[locale] || address.en);

      return renderCompanyBranch(localizedName, formattedAddress, isNameAtDefaultLang);
    });
  };

  const renderCompanyLogo = () => (
    <div className={styles.companyLogo}>
      {props.company.is_community_member &&
        <Link to={appendLocale(props.locale, '/professionals/broker')}>
          <span className={styles.communityStamp} style={communityLogo} />
        </Link>
      }
      {props.company.is_association_member &&
        <Link to={appendLocale(props.locale, '/professionals')}>
          <span className={styles.associationStamp} style={associationLogo} />
        </Link>
      }
      {props.company.has_purple_stamp &&
        <Link to={PURPLE_STAMP_ARTICLE_LINK}>
          <span
            className={cx(styles.purpleStamp, { [styles.withBroker]: props.company.is_community_member })}
            style={purpleStampLogo}
          />
        </Link>
      }
      <div className={styles.logoImg}>
        <img src={props.companyLogo} alt="" />
      </div>
    </div>
  );

  const renderCompanyName = () => (
    <div className={styles.infoBlock_title}>
      <h1>{props.companyName}</h1>
    </div>
  );

  const renderPhones = () => (
    <HeaderPhones
      translate={props.translate}
      phoneNumber={props.phoneNumber}
      locale={props.locale}
      isMobile={props.isMobile}
    />
  );

  return (
    <div className={styles.wrapper}>
      { renderCompanyLogo() }
      <div className={cx(styles.infoBlock, { [styles.withCommunity]: props.company.is_community_member })}>
        {props.companyName && (
          renderCompanyName()
        )}
        {props.phoneNumber && renderPhones()}

        {renderCompanyBranches()}
      </div>
    </div>
  );
};

AboutCompany.propTypes = {
  isMobile: PropTypes.bool,
  company: PropTypes.object,
  onShowPhones: PropTypes.func,
  translate: PropTypes.func,
  branches: PropTypes.array,
  companyLogo: PropTypes.string,
  companyName: PropTypes.string,
  locale: PropTypes.string,
  is_association_member: PropTypes.bool,
  phoneNumber: PropTypes.string,
  address: PropTypes.string,
  isNameAtDefaultLang: PropTypes.bool,
  isShowPhone: PropTypes.bool
};

export default AboutCompany;
